// extracted by mini-css-extract-plugin
export var leftAlign = "_24-2";
export var popper = "_24-0";
export var subtitle = "_24-1";